// 悟空宝盒
import React, { useContext } from 'react';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import cls from 'classnames';

import { PC, Mobile } from '@wukong/haomao';
import { MyContext } from '../../../../config/context-manager';

import styles from './style.module.scss';

const PointBox = () => {
  const { t } = useTranslation('chineseSpecialty');
  return (
    <div className={styles.pointContainer}>
      <div className={styles.point}>{t('悟空宝盒-特点-1')}</div>
      <div className={styles.point}>{t('悟空宝盒-特点-2')}</div>
      <div className={styles.point}>{t('悟空宝盒-特点-3')}</div>
    </div>
  );
};

const StudyArtifact = () => {
  const { t } = useTranslation('chineseSpecialty');
  const { locale } = useContext(MyContext);
  return (
    <section
      className={cls(styles.container, {
        [styles.localeEn]: locale === 'en',
      })}
    >
      <PC>
        <div>
          <div className={styles.bg}>
            <Image
              src="/images/chinese-math-class/chinese/specil/artifact-bg.png"
              layout="fill"
              objectFit="cover"
              priority
              alt=""
            />
          </div>
          <div className={styles.wukongBoxBg}>
            <div className={styles.wukongBoxImg}>
              <Image
                src="/images/chinese-math-class/chinese/specil/artifact-box-img.png"
                layout="fill"
                objectFit="cover"
                priority
                alt=""
              />
            </div>
            <div className={styles.blurBox} />
          </div>
          <PointBox />
        </div>
      </PC>

      <div className={styles.titleContainer}>
        <h3 className={styles.title}>
          <p dangerouslySetInnerHTML={{ __html: t('悟空宝盒-标题-1') }} />
          <p dangerouslySetInnerHTML={{ __html: t('悟空宝盒-标题-2') }} />
          <Mobile>
            <span className={styles.round} />
          </Mobile>
        </h3>
        <p className={styles.subTitle}>{t('悟空宝盒-副标题')}</p>
        <Mobile>
          <div>
            <div className={styles.mArtifactContainer}>
              <div className={styles.mArtifactBg}>
                <Image
                  src="/images/chinese-math-class/chinese/specil/artifact-box-img-m.png"
                  width={267}
                  height={220}
                  layout="responsive"
                  alt=""
                />
              </div>
              <PointBox />
            </div>
          </div>
        </Mobile>
        <ul className={styles.contentContainer}>
          <li className={styles.contentItem}>
            <div className={styles.iconBox}>
              <Image
                src="/images/chinese-math-class/chinese/specil/artifact-content-icon.png"
                width={36}
                height={30}
                alt=""
              />
            </div>
            <p>{t('悟空宝盒-内容-1')}</p>
          </li>
          <li className={styles.contentItem}>
            <div className={styles.iconBox}>
              <Image
                src="/images/chinese-math-class/chinese/specil/artifact-content-icon.png"
                width={36}
                height={30}
                alt=""
              />
            </div>
            <p>{t('悟空宝盒-内容-2')}</p>
          </li>
          <li className={styles.contentItem}>
            <div className={styles.iconBox}>
              <Image
                src="/images/chinese-math-class/chinese/specil/artifact-content-icon.png"
                width={36}
                height={30}
                alt=""
              />
            </div>
            <p>{t('悟空宝盒-内容-3')}</p>
          </li>
          <li className={styles.contentItem}>
            <div className={styles.iconBox}>
              <Image
                src="/images/chinese-math-class/chinese/specil/artifact-content-icon.png"
                width={36}
                height={30}
                alt=""
              />
            </div>
            <p>{t('悟空宝盒-内容-4')}</p>
          </li>
        </ul>
      </div>
    </section>
  );
};

export default StudyArtifact;
